import { api } from './api';

export interface CarnivalStyleRecommended {
  model: string;
  size: string;
  output_format: string;
  input_fidelity: string;
}

export interface CarnivalStyle {
  _id: string;
  image: { original: { url: string; _id?: string; size?: number } };
  name: string;
  description: string;
  active: boolean;
  id: string;
  promptStyle: string | string[];
  recommended: CarnivalStyleRecommended;
  created?: number;
  updated?: number;
}

export interface CarnivalImage {
  url?: string;
  imageUrl?: string;
  _id: string;
  createdAt?: number | { $date?: number };
  limit?: number;
  saved?: boolean;
}

export interface CarnivalImageData {
  latest: CarnivalImage | null;
  latestGenerated: CarnivalImage | null;
  total: number;
  limit: number;
  limitReached: boolean;
}

function getCarnivalImageUrl(image?: CarnivalImage | null) {
  if (!image) return '';
  return image.url || image.imageUrl || '';
}

export async function getStylesAi(): Promise<CarnivalStyle[] | null> {
  try {
    const { data } = await api.post('find/get_styles_ai', {});
    if (!Array.isArray(data)) return null;
    return data.filter((style: CarnivalStyle) => style.active);
  } catch (e) {
    return null;
  }
}

export async function getImgCarnaval(): Promise<CarnivalImageData> {
  try {
    const { data } = await api.post('find/get_img_carnaval', {});
    if (!Array.isArray(data) || !data.length) {
      return { latest: null, latestGenerated: null, total: 0, limit: 0, limitReached: false };
    }
    const imagesWithUrl = data.filter((item: CarnivalImage) => !!getCarnivalImageUrl(item));
    const savedImages = imagesWithUrl.filter((item: CarnivalImage) => item?.saved === true);
    const limit = data.find((item: CarnivalImage) => typeof item?.limit === 'number')?.limit || 0;
    const total = imagesWithUrl.length;
    const latestSaved = savedImages.length > 0 ? (savedImages[0] as CarnivalImage) : null;
    const latestGenerated = imagesWithUrl.length > 0 ? (imagesWithUrl[0] as CarnivalImage) : null;
    return {
      latest: latestSaved && getCarnivalImageUrl(latestSaved) ? latestSaved : null,
      latestGenerated: getCarnivalImageUrl(latestGenerated) ? latestGenerated : null,
      total,
      limit,
      limitReached: limit > 0 && total >= limit,
    };
  } catch (e) {
    return { latest: null, latestGenerated: null, total: 0, limit: 0, limitReached: false };
  }
}
